import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login.component';
import { NotifierModule } from 'angular-notifier';
// import {DataTableModule} from 'angular2-datatable';
// import { UiSwitchModule } from 'ngx-ui-switch';
// import { Searchfilter } from '../common/Searchfilter';

const routerConfig = [{
  path: '',
  component: LoginComponent
}];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routerConfig),
    FormsModule , ReactiveFormsModule,NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'right',
          distance: 12
        },
        vertical: {
          position: 'top',
          distance: 12,
          gap: 10
        }
      },
      theme: 'material',
      behaviour: {
        autoHide: 3000,
        onClick: false,
        onMouseover: 'pauseAutoHide',
        showDismissButton: false,
        stacking: 1
      },
      animations: {
        enabled: true,
        show: {
          preset: 'slide',
          speed: 200,
          easing: 'ease'
        },
        hide: {
          preset: 'fade',
          speed: 300,
          easing: 'ease',
          offset: 50
        },
        shift: {
          speed: 300,
          easing: 'ease'
        },
        overlap: 150
      }
    })
  ],
  declarations: [
    LoginComponent 
  ],
  exports: [
    LoginComponent
  ],
  providers: []
})

export class LoginModule { }

